export const ORG_PREFIX = '/o/:orgId';

export const ROUTES = {
  // Core Routes
  HOME: '/',

  // Dashboard
  COMPOSER_DASHBOARD: '/composer-dashboard',

  // Chat Home (org-wide chat with the primary agent, replaces Builder Agent)
  CHAT_HOME: {
    ROOT: '/chat-home',
    CONVERSATION: '/chat-home/:conversationId',
  },

  // Chats (list of the user's conversations with the primary agent)
  CHATS: '/chats',

  // Workflow
  WORKFLOW: {
    ROOT: '/workflow',
    EDITOR: '/workflow/:workflowId',
  },

  // Workflow Builder (user-facing chat with pre-configured agent)
  WORKFLOW_BUILDER: '/workflow-builder',

  // Chat Agents
  CHAT_AGENTS: {
    ROOT: '/chat-agents',
    NEW: '/chat-agents/new',
    CONFIG: '/chat-agents/:agentId/config',
    CHAT: '/chat-agents/:agentId/chat',
  },

  // Distinct from CHAT_AGENTS: per-org agents that external A2A peers call
  // into, each with its own bearer + runtime canvas.
  AGENTS: {
    ROOT: '/agents',
    NEW: '/agents/new',
    CONFIG: '/agents/:agentId/config',
    CHAT: '/agents/:agentId/chat',
    PEER_AGENTS: '/agents/peer-agents',
  },

  SOURCES: {
    ROOT: '/sources',
  },

  // Data Sources
  DATA_SOURCES: {
    ROOT: '/data-sources',
    COLLECTIONS: '/data-sources/:collectionId',
    COLLECTIONS_DATASETS: '/data-sources/:collectionId/datasets',
    COLLECTION_DATASET_DETAIL:
      '/data-sources/:collectionId/datasets/:datasetId',
  },

  // Context Graphs
  CONTEXT_GRAPHS: {
    ROOT: '/context-graphs',
  },

  // Documentation
  DOCS: {
    ROOT: '/docs',
    WORKFLOW_API: '/docs/workflow-api',
  },

  // Guardrails
  GUARDRAILS: {
    ROOT: '/guardrails',
  },

  // Main Navigation
  MEMBERS: '/members',
  ORGANIZATION: '/organization',

  // Auth
  LOGIN: '/login',

  // Skills
  SKILLS: '/skills',

  // Artifacts
  ARTIFACTS: '/artifacts',
  ARTIFACT_DETAIL: '/artifacts/:artifactId',

  // Files (Capitol file store: org-scoped file repos behind capitol-filestore-svc)
  FILES: {
    ROOT: '/files',
    REPO: '/files/:repo/*',
  },

  // Schedules & Runs
  SCHEDULES: {
    ROOT: '/schedules',
  },

  // Triggers (event-driven runs)
  TRIGGERS: {
    ROOT: '/triggers',
  },

  // Evaluation
  EVALUATION: {
    ROOT: '/evaluation',
    EVALUATIONS: '/evaluation/evals',
    EVALUATION_SETTINGS: '/evaluation/evals/:evalId',
    TESTS: '/evaluation/tests',
    TESTS_SETTINGS: '/evaluation/tests/:testId',
    API_DOC: '/evaluation/api-doc',
  },

  // Admin
  ADMIN: {
    ROOT: '/admin',
    USERS: '/admin/users',
    ORGS: '/admin/orgs',
    ORG_DETAILS: '/admin/orgs/:orgId',
    ANALYTICS_CONFIG: '/admin/analytics-config',
    WORKFLOW_AGENT: '/admin/workflow-agent',
    COST: '/admin/cost',
    UAT: '/admin/uat',
  },

  // Settings
  // Personal, not org-scoped: everything under SETTINGS belongs to the org.
  ACCOUNT: {
    ROOT: '/account',
    API_TOKENS: '/account/api-tokens',
    CONNECTORS: '/account/connectors',
    AI_APPS: '/account/ai-apps',
  },

  SETTINGS: {
    ROOT: '/settings',
    GENERAL: '/settings/general',
    MEMBERS: '/settings/members',
    API_KEY: '/settings/api-key',
    NODES: '/settings/nodes',
    MY_TOOLS: '/settings/my-tools',
    MCP_SERVERS: '/settings/mcp-servers',
    LABELS: '/settings/labels',
    ENCRYPTION: '/settings/encryption',
    A2A_IP_ALLOWLIST: '/settings/a2a-ip-allowlist',
  },

  // Legacy redirects (kept for bookmarks / old links)
  LEGACY: {
    KEYS_CAPITOL: '/keys/capitol',
  },

  // Embed (iframe) routes — no platform auth
  EMBED: {
    CHAT: '/embed/chat/:orgId/:collectionId',
    SEARCH: '/embed/search/:orgId/:collectionId',
  },
} as const;
